module.exports = __webpack_public_path__ + "media/images/icon/icons8-Exit-570db944483a64b429679a451caebcb6.png";